import { useRouter } from "next/router";
import useTranslation from "next-translate/useTranslation";
import { ArrowRightIcon } from "@heroicons/react/outline";
import React from "react";
import NextLink from "components/NextLink";

export default function TermList({ terms }) {
  const router = useRouter();
  const { t } = useTranslation("common");

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      {terms?.map((term) => {
        const hasParent =
          terms.filter((item) => item.id === term.parent[0].id).length > 0;
        if (!hasParent) {
          return (
            <div
              className="group relative h-full bg-primary text-white rounded-lg shadow-spread overflow-hidden cursor-pointer hover:bg-primary-dark transition-colors"
              onClick={() => router.push(term.path.alias)}
              key={term.id}
            >
              <div className="p-10">
                <div className="font-important text-xl mb-8">{term.name}</div>
                <NextLink
                  href={term.path.alias}
                  className="inline-block bg-white rounded-full p-2"
                >
                  <ArrowRightIcon className="w-5 h-5 text-primary" />
                  <span className="sr-only">{t("utils.more_link")}</span>
                </NextLink>
              </div>
            </div>
          );
        }

        return null;
      })}
    </div>
  );
}
